import React, { FC } from 'react'
import { BreadType } from 'types/bread'
import { Card, BreadCard } from 'components/Card'
import { CategoryType } from 'types/category'
import { StockType } from 'types/stock'
import { getBreadShortName } from 'lib/helper'

type Props = {
  breads: BreadType[]
  categories: CategoryType[]
  stocks: StockType[]
}

const BreadCardList: FC<Props> = (props) => {
  const { breads, categories, stocks } = props

  return (
    <Card>
      {breads.length > 0 &&
        categories.length > 0 &&
        breads.map((bread, index) => {
          if (!bread.bread_ref) return <React.Fragment key={index.toString()} />
          const preorderStocks = stocks.filter((stock) => {
            return stock.bread_ref.id === bread.bread_ref?.id && stock.type === 'preorder'
          })
          // 移行前のカテゴリ未設定商品に対する対応
          if (!bread.category) {
            return (
              <BreadCard
                key={bread.bread_ref.id}
                breadId={bread.bread_ref.id}
                breadName={getBreadShortName(bread)}
                categoryName={'未設定'}
                isTypeDaily={bread.is_type_daily}
                isTypePreorder={bread.is_type_preorder}
                isTypeDelivery={bread.is_type_delivery}
                preorderStocks={preorderStocks}
                imageUrl={bread.image_urls[0] || ''}
                status={bread.status}
                updatedAt={bread.updated_at}
              />
            )
          } else {
            const category = categories.find((category) => category.category_ref.id === bread.category.id)
            if (!category) return <React.Fragment key={bread.bread_ref.id} />

            return (
              <BreadCard
                key={bread.bread_ref.id}
                breadId={bread.bread_ref.id}
                breadName={getBreadShortName(bread)}
                categoryName={category.name}
                isTypeDaily={bread.is_type_daily}
                isTypePreorder={bread.is_type_preorder}
                isTypeDelivery={bread.is_type_delivery}
                preorderStocks={preorderStocks}
                imageUrl={bread.image_urls[0] || ''}
                status={bread.status}
                updatedAt={bread.updated_at}
              />
            )
          }
        })}
    </Card>
  )
}

export default BreadCardList
